import { CommonModule, NgTemplateOutlet } from "@angular/common";
import { Component, computed, input, TemplateRef } from "@angular/core";

type Placement = "left" | "right";
type InfoType = "entityName" | "deficitIrrigation" | "coverCrop";

const INFO_CONTENT: Record<InfoType, { header: string; body: string }> = {
  entityName: {
    header: "Note:",
    body: "Optional. Grant view-only access to this field. Select an existing entity from your account, or add a new one, they'll receive an email invitation to sign up and view the field.",
  },
  deficitIrrigation: {
    header: "Note:",
    body: "Reduction of irrigation amounts lower than crop's potential water use. Usually used due to lack of water availability or to improve fruit and nut quality.",
  },
  coverCrop: {
    header: "Cover Crop:",
    body: "Crop planted intentionally between tree or vine rows, usually for the purposes of soil health building and active during winter and spring",
  },
};

@Component({
  selector: "app-graph-popover-instruction",
  standalone: true,
  imports: [CommonModule, NgTemplateOutlet],
  templateUrl: "./graph-popover-instruction.component.html",
  styleUrl: "./graph-popover-instruction.component.scss",
})
export class GraphPopoverInstructionComponent {
  isHovered = false;
  popoverTimeout: any; // prevent the popover to close right away, causing jittering for user
  readonly customSVG = input<TemplateRef<any>>();
  readonly useDefaultContent = input<boolean>(false);
  readonly placement = input<Placement>("left");
  readonly infoType = input<InfoType | null>(null);

  readonly info = computed(() => {
    const type = this.infoType();
    return type ? INFO_CONTENT[type] : null;
  });

  readonly onMouseEnter = () => {
    clearTimeout(this.popoverTimeout);
    this.isHovered = true;
  };

  readonly onMouseLeave = () => {
    this.popoverTimeout = setTimeout(() => {
      this.isHovered = false;
    }, 200);
  };
}
